import { docsConstants } from "src/_constants";

export function docsReducer(state = { docs: [], categories: [] }, actions) {
    switch (actions.type) {

        // get all doc
        case docsConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case docsConstants.GETALL_SUCCESS:
            return {
                ...state,
                loading: false,
                docs: actions.docs,
            }
        case docsConstants.GETALL_FAILURE:
            return {
                ...state,
                error: actions.error
            }

        // get a doc by ID    
        case docsConstants.GET_REQUEST:
            return {
                ...state,
                loading: true
            }
        case docsConstants.GET_SUCCESS:
            return {
                ...state,
                doc: actions.doc,
                loading: false
            }
        case docsConstants.GET_FAILURE:
            return {
                ...state,
                error: actions.error
            };
        // add new doc    
        case docsConstants.ADD_REQUEST:
            return {
                ...state,
                loading: true
            }
        case docsConstants.ADD_SUCCESS:
            var docs = state.docs ? state.docs : [];
            docs.push(actions.doc);
            return {
                ...state,
                docs: docs,
                loading: false
            }
        case docsConstants.ADD_FAILURE:
            return {
                ...state,
                error: actions.error
            };
        // update doc    
        case docsConstants.UPDATE_REQUEST:
            return {
                ...state,
                //loading: true
            }
        case docsConstants.UPDATE_SUCCESS:
            var _docs = state.docs;
            var foundIndex = _docs.findIndex(item => item.id === actions.doc.id);
            actions.doc['index'] = foundIndex;
            _docs[foundIndex] = actions.doc;
            console.log(foundIndex);
            return {
                ...state,
                //loading: false,
                docs: _docs,
                doc: actions.doc,
            }
        case docsConstants.UPDATE_FAILURE:
            return {
                ...state,
                error: actions.error
            };
        // update doc field    
        case docsConstants.UPDATE_FIELD_REQUEST:
            return {
                ...state,
                loading: false
            }
        case docsConstants.UPDATE_FIELD_SUCCESS:
            var _docs = state.docs;
            var foundIndex = _docs.findIndex(item => item.id === actions.doc.id);
            actions.doc['index'] = foundIndex;
            _docs[foundIndex] = actions.doc;
            console.log(foundIndex);
            return {
                ...state,
                loading: false,
                docs: _docs,
                doc: actions.doc,
            }
        case docsConstants.UPDATE_FIELD_FAILURE:
            return {
                ...state,
                error: actions.error
            };

        // CATEGORIES
        // get all category
        case docsConstants.CAT_GETALL_REQUEST:
            return {
                ...state,
                loading_cat: true,
            }
        case docsConstants.CAT_GETALL_SUCCESS:
            return {
                ...state,
                loading_cat: false,
                categories: actions.categories,
            }
        case docsConstants.CAT_GETALL_FAILURE:
            return {
                ...state,
                error: actions.error
            }
        // get a cat by ID    
        case docsConstants.CAT_GET_REQUEST:
            return {
                ...state,
                loading_cat: true
            }
        case docsConstants.CAT_GET_SUCCESS:
            return {
                ...state,
                category: actions.category,
                loading_cat: false
            }
        case docsConstants.CAT_GET_FAILURE:
            return {
                ...state,
                error: actions.error
            };
        // add new category
        case docsConstants.CAT_ADD_REQUEST:
            return {
                ...state,
                loading_cat: true
            }
        case docsConstants.CAT_ADD_SUCCESS:
            var _categories = state.categories ? state.categories : [];
            _categories.push(actions.category);
            return {
                ...state,
                categories: _categories,
                loading_cat: false
            }
        case docsConstants.CAT_ADD_FAILURE:
            return {
                ...state,
                error: actions.error
            };
        // update category    
        case docsConstants.CAT_UPDATE_REQUEST:
            return {
                ...state,
                loading_cat: true
            }
        case docsConstants.CAT_UPDATE_SUCCESS:
            var _categories = state.categories;
            var foundIndex = _categories.findIndex(item => item.id === actions.category.id);
            actions.category['index'] = foundIndex;
            _categories[foundIndex] = actions.category;
            return {
                ...state,
                loading_cat: false,
                categories: _categories,
                category: actions.category,
            }
        case docsConstants.CAT_UPDATE_FAILURE:
            return {
                ...state,
                error: actions.error
            };
        // update category field    
        case docsConstants.CAT_UPDATE_FIELD_REQUEST:
            return {
                ...state,
                loading_cat: false
            }
        case docsConstants.CAT_UPDATE_FIELD_SUCCESS:
            var _categories = state.categories;
            var foundIndex = _docs.findIndex(item => item.id === actions.category.id);
            actions.category['index'] = foundIndex;
            _docs[foundIndex] = actions.category;
            return {
                ...state,
                loading_cat: false,
                categories: _categories,
                category: actions.category,
            }
        case docsConstants.CAT_UPDATE_FIELD_FAILURE:
            return {
                ...state,
                loading_cat: false,
                error: actions.error
            };


        default:
            return state;
    }
}